module.exports = __webpack_public_path__ + "media/images/smart_phone/item/rate_2_5-baa362c046d59cc2230680ea754da1a1.png";